<template>
  <button type="button" class="HandshakePhotoTile">
    <GamIcon :name="GamIconName.IMAGE" size="22px" is-current />
    <span>{{ label }}</span>
  </button>
</template>

<script setup lang="ts">
import GamIcon from '@/views/components/GamIcon.vue';
import { GamIconName } from '@/views/composables/constants/components/gamIcon.constants';

defineProps<{ label: string }>();
</script>

<style lang="scss" scoped>
@use '@/ui/css/mixins' as *;

/* The empty photo tile of a played position, kept short so the buttons below stay on screen. */
.HandshakePhotoTile {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-md);
  width: 100%;
  height: 64px;
  border: 0;
  border-radius: var(--radius-small);
  background: var(--color-dark-500);
  color: var(--color-white-70);
  font-family: inherit;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 200ms ease,
    color 200ms ease;

  @include hover {
    background: linear-gradient(var(--color-white-8), var(--color-white-8)), var(--color-dark-500);
    color: var(--color-white);
  }

  @include press;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
